<template>
  <router-link tag="button" :to="'/abstract/' + abstract.id + '/submit'"
               class="btn btn-link mx-auto"
               v-if="abstract.status_id == 1 && isOpen">
    <icon :icon="['fad', 'file-signature']" class="text-success"/>
    <br>
    {{wording[0].buttons.submit}}
  </router-link>
  <button class="btn btn-link disabled mx-auto" v-else>
    <icon :icon="['fad', 'file-signature']"/>
    <br>
    {{wording[0].buttons.submit}}
  </button>
</template>
<script>
  export default {
    name: 'SubmitArea',
    props: {
      abstract: {},
      isOpen: {},
      wording: {}
    }
  }
</script>
<style scoped>
  @media (min-width: 10em) {
  }
</style>